import get from "lodash/get"
import axios from "axios"
import {
  GET_CONTACT_BACK_ATTRIBUTES_FAILED,
  GET_CONTACT_BACK_ATTRIBUTES_FULFILLED,
  GET_CONTACT_BACK_ATTRIBUTES_PENDING,
} from "constants-lib/actionTypes"
import URITemplate from "urijs/src/URITemplate"
import { urls } from "utils-lib/builds"
import isEmpty from "lodash/isEmpty"
import { generateUniqueID } from "utils-lib/requests"

export const pendingAC = () => ({
  type: GET_CONTACT_BACK_ATTRIBUTES_PENDING,
})

export const failedAC = () => ({
  type: GET_CONTACT_BACK_ATTRIBUTES_FAILED,
})

export const fulfilledAC = (data) => ({
  type: GET_CONTACT_BACK_ATTRIBUTES_FULFILLED,
  payload: data,
})

/**
 * Fetches contact back attributes based on the provided parameters.
 * @param {Object} params - The parameters for the function.
 * @param {string} params.category - The category of the contact.
 * @param {Array} params.subCategory - The subcategories of the contact.
 * @param {string} params.lineOfBusiness - The line of business of the contact.
 * @param {Object} params.customerAddress - The address of the customer.
 * @param {string} params.customerAddress.streetName - The street name of the customer's address.
 * @param {string} params.customerAddress.streetNumber - The street number of the customer's address.
 * @param {string} params.customerAddress.city - The city of the customer's address.
 * @param {string} params.customerAddress.state - The state of the customer's address.
 * @param {string} params.customerAddress.country - The country of the customer's address.
 * @param {string} params.customerAddress.postalCode - The postal code of the customer's address.
 * @param {string} params.customerAddress.lat - The latitude of the customer's address.
 * @param {string} params.customerAddress.lng - The longitude of the customer's address.
 * @returns {function} A function that takes the Redux dispatch function as an argument.
 */
export const getContactBackAttributes =
  ({ category, subCategory = [], lineOfBusiness = "", customerAddress }) =>
  (dispatch, getState) => {
    const correctedSubCategory =
      !isEmpty(subCategory) && subCategory?.join(" - ")
    const { cancelService } = getState()
    const isMovingFlow = get(cancelService, `isMovingLoggedInFlow`, false)
    const moversCategory = `Change, Add, Pause or Cancel Services`
    const moversSubCategory = `Moving (Transfer) Service`

    const street = `${get(customerAddress, "streetName", "")} ${get(
      customerAddress,
      "streetNumber",
      "",
    )}`
    const api = `CONTACT_BACK_ATTRIBUTES`
    const template = URITemplate(urls.url[api])
    const url = template.expand({
      category: isMovingFlow ? moversCategory : category,
      subCategory: isMovingFlow
        ? moversSubCategory
        : correctedSubCategory || "null",
      lineOfBusiness,
      latitude: get(customerAddress, "lat", ""),
      longitude: get(customerAddress, "lng", ""),
      street,
      city: get(customerAddress, "city", ""),
      state: get(customerAddress, "state", ""),
      country: get(customerAddress, "country", ""),
      postalCode: get(customerAddress, "postalCode", ""),
    })

    dispatch(pendingAC())

    const config = {
      headers: {
        "Request-Tracking-Id": generateUniqueID(),
        "Source-App": `WM.com`,
      },
    }
    return axios
      .get(url, config)
      .then((response) => {
        dispatch(fulfilledAC(response.data))
        return response.data
      })
      .catch((error) => {
        dispatch(failedAC((error, `response.status`, ``)))
        return error
      })
  }
